import type { EndpointDefinition } from "../../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getWorkspacePlanData: {
        route: "/workspaces/:workspaceId/billing/plan",
        method: "GET"
    },
    upgradeWorkspacePlan: {
        route: "/workspaces/:workspaceId/billing/upgrade",
        method: "POST"
    },
    finalizeUpgradeWorkspacePlan: {
        route: "/workspaces/:workspaceId/billing/upgrade/finalize",
        method: "POST"
    },
    abortUpgradeWorkspacePlan: {
        route: "/workspaces/:workspaceId/billing/upgrade/abort",
        method: "POST"
    },
    getAvailableTrialDays: {
        route: "/workspaces/any/billing/trial-days",
        method: "GET"
    }
};
